import { render, staticRenderFns } from "./Qiniu.vue?vue&type=template&id=47893d98&scoped=true"
import script from "./Qiniu.vue?vue&type=script&lang=js"
export * from "./Qiniu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47893d98",
  null
  
)

export default component.exports